import React, { useEffect, useState, useRef } from "react";
import { Button, Typography } from "@material-ui/core";
import localforage from "localforage";
import { useTranslation } from "@/langs/useTranslation";
import CompanyTreeModal from "./Modal";
import { ArrowDropDown } from "@material-ui/icons";
import {getAccountInfo} from "@/apis/apiCollection";
import {makeStyles} from '@material-ui/core/styles';
import { useGroupDeviceDispatch, useGroupDeviceState } from "../Provider"

function getCompanyMap() {
  return JSON.parse(sessionStorage.getItem("companiesMap") || "{}");
}

const useStyles = makeStyles(theme => {
  return {
    selectCompany: {
      backgroundColor: "#f8f9fc",
      marginBottom: "10px",
      '& .MuiButtonBase-root.MuiButton-root.MuiButton-text': {
        width: "100%",
        '& .MuiButton-label' :{
          justifyContent: 'space-between'
        }
      },
      "& button": {
        "& .MuiTypography-button": {
          "white-space": "nowrap",
          overflow: "hidden"
        }
      }
    }
  }
})

const CompanySelector = ({ onSelect, companyId,isAppBar }) => {
  const [companyTreeModalOpen, setCompanyTreeModalOpen] = useState(false);
  // const [companyName, setCompanyName] = useState(() => {
  //   return getCompanyMap()[companyId] || "";
  // });

  const {currentCompanyId, currentCompanyName} = useGroupDeviceState()
  const {setCurrentCompany} = useGroupDeviceDispatch()

  const bc = useRef(null);
  const { t } = useTranslation();

  const classes = useStyles()

  const handleClick = () => {
    setCompanyTreeModalOpen(true);
  };

  const handleClose = () => setCompanyTreeModalOpen(false);

  // 头部点击选择公司
  const handleHeaderCompanySelect = (selectedKey, selectedNode) => {
    setCurrentCompany(selectedNode.node.key,selectedNode.node.name)
    handleClose();
    onSelect?.(selectedKey, selectedNode);
    const prevCompanyMap = getCompanyMap();
    sessionStorage.setItem(
      "companiesMap",
      JSON.stringify({
        ...prevCompanyMap,
        [selectedKey[0]]: selectedNode.node.name
      })
    );
    bc.current?.postMessage("test");
  }

  const handleCompanySelect = (selectedKey, selectedNode) => {
    setCurrentCompany(selectedNode.node.key,selectedNode.node.name)
    handleClose();
    onSelect?.(selectedKey, selectedNode);
    const prevCompanyMap = getCompanyMap();
    sessionStorage.setItem(
      "companiesMap",
      JSON.stringify({
        ...prevCompanyMap,
        [selectedKey[0]]: selectedNode.node.name
      })
    );
    bc.current?.postMessage("test");
  };


  useEffect(() => {
    return () => {
      bc.current?.close();
    };
  }, []);

  return (
    <div className={classes.selectCompany}>
      <Button endIcon={<ArrowDropDown />} onClick={handleClick}>
        <Typography variant="button">
          {currentCompanyName || t({ defaultMessage: "全部公司" })}
        </Typography>
      </Button>
      <CompanyTreeModal
        open={companyTreeModalOpen}
        companyId={currentCompanyId}
        checkable={false}
        footer={null}
        onClose={handleClose}
        onSelect={isAppBar ? handleHeaderCompanySelect : handleCompanySelect}
      />
    </div>
  );
};

export default CompanySelector;
